// extracted by mini-css-extract-plugin
export default {"badge":"eAo6m","topLeft":"TJblT","topRight":"_9dhz4","bottomLeft":"a9IbK","bottomRight":"_4AV6F"};